type Config = {
  siteName: string;
  googleTagManagerId: string;
  vwoAccountId: string;
  header: {
    logo: {
      url: string;
      description?: string;
    };
    logoMobile: {
      url: string;
      description?: string;
    };
  };
  services: {
    prod: {
      EAPI_REST_URL: string;
      EAPI_GRAPHQL_URL: string;
    };
    nonprod: {
      EAPI_REST_URL: string;
      EAPI_GRAPHQL_URL: string;
      GOOGLE_MAP_API_KEY: string;
    };
  };
};

const config: Config = {
  siteName: "Aspen Dental - Scheduling",
  googleTagManagerId: "GTM-NTW7353",
  vwoAccountId: "613301",
  header: {
    logo: {
      url: "https://images.ctfassets.net/m8zwsu9tyucg/3AZGZPc19pKGc3fcpaoyTj/5d1aecc113c6290bcef8ed2b380543c8/AspenDental_logo_RGB_Navy__1_.svg",
      description: "AspenDental Logo",
    },
    logoMobile: {
      url: "https://images.ctfassets.net/m8zwsu9tyucg/7jzYqWlL2Z1NyUWPgR7mpc/922ffe5db0d5cd28bcb42653e7d9a5e6/AspenLogoDark.svg",
      description: "AspenDental Logo",
    },
  },
  services: {
    prod: {
      EAPI_REST_URL: "https://api.aspendental.com/api/web/",
      EAPI_GRAPHQL_URL: "https://api.aspendental.com/websitegraphql/graphql/",
    },
    nonprod: {
      EAPI_REST_URL: "https://apistg.aspendental.com/api/web/",
      EAPI_GRAPHQL_URL: "https://apistg.aspendental.com/websitegraphql/graphql/",
      GOOGLE_MAP_API_KEY: "AIzaSyA_SMV0ZyKn3u0uD1dPUhcVpaXpQWGvcCc",
    },
  },
};

export default config;
